import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { AiFillEdit } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { deletePresets } from "../logic/categories/action";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const FormsTable = () => {
  const selector = useSelector((state) => state.categories);
  const dispatch = useDispatch();
  const {id} = useParams();

  const columnDefs = useMemo(() => [
    {
      field: 'form_id',
      headerName: 'Id',
      width: 100,
      cellRenderer: (params) => (
        <Link to={"/business/" + params.value} style={{ color: '#1976d2', textDecoration: 'underline' }}>
          {params.value}
        </Link>
      )
    },
    {
      field: 'name',
      headerName: 'Form Name',
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => params.value ? params.value.charAt(0).toUpperCase() + params.value.slice(1) : ''
    },
    {
      field: 'fields',
      headerName: 'Fields',
      flex: 1,
      minWidth: 200,
      valueFormatter: (params) => JSON.stringify(params.value)
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      cellRenderer: (params) => {
        return (
          <span className="flex gap-4 justify-center items-center">
            <Link to={`/admin/categories/${id}/forms/${params.data?.form_id}`}>
              <AiFillEdit
                size={'1.5rem'}
                className="cursor-pointer"
              />
            </Link>
            <MdDelete 
              className="cursor-pointer"
              onClick={() => {
                deletePresets(dispatch, id, params.data?.form_id);
              }}
              size={'1.5rem'} 
              color={'red'}
            />
          </span>
        );
      },
      sortable: false,
      filter: false
    }
  ], [id, dispatch]);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    filter: true,
    resizable: true
  }), []);

  return (
    <div className="ag-theme-alpine" style={{ height: '400px', width: '100%', padding: '16px' }}>
      <AgGridReact
        rowData={selector?.presets || []}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        pagination={true}
        paginationPageSize={10}
        animateRows={true}
      />
    </div>
  );
};

export default FormsTable;
